<template>
  <div>
     <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handlerSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="data"
    >
      <el-table-column
        prop="user_id"
        label="出单人Uid"
      />
      <el-table-column
        label="头像"
      >
        <template slot-scope="{row}">
            <el-image style="width: 50px;" :src="row.avatar"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称"
      />
      <el-table-column
        prop="id"
        label="图铃订单号"
      />
      <el-table-column
        prop="ware_name"
        label="产品名称"
      />
      <el-table-column
        prop="applicant_name"
        label="投保人"
      />
      <el-table-column
        prop="insurant_name"
        label="被保险人"
      />
      <el-table-column
        prop="premium"
        label="保费"
        :formatter="function(v) { return v['premium'] / 100 + ' 元' }"
      />
      <el-table-column
        prop="insure_time"
        label="缴费时间"
      />
      <el-table-column
        prop="status"
        label="订单状态"
        :formatter="function(v) { return statusMap[v['status']] }"
      />
      <el-table-column
        prop="provider"
        label="出单平台"
      />
        <el-table-column
            prop="source"
            label="来源"
        />
      <el-table-column
        prop="provider_id"
        label="渠道订单号"
      />
      <el-table-column
        prop="commission"
        label="用户税前奖励"
        :formatter="function(v) { return v['commission'] / 100 + ' 元' }"
      />
      <el-table-column
        prop="base_commission"
        label="平台收入"
        :formatter="function(v) { return v['base_commission'] / 100 + ' 元' }"
      />
    </el-table>

    <pager
      api="order_list"
      :filter="filter"
      :sort="sort"
      model="policy"
      @data-changed="onDataChanged"
    />
  </div>
</template>
<script>
  import Pager from "../ui/Pager"

  export default {
    name: 'OrderList',
    components: { Pager },
    data () {
      return {
        searchData: {},
        data: [],
        filter: {},
        sort: [],
        statusMap: {
          0: '空',
          10000: '核保',
          10100: '核保成功',
          91000: '核保失败',
          12000: '支付',
          12100: '待支付',
          12200: '支付成功',
          91200: '待支付过期',
          13000: '出单',
          13100: '出单完成',
          13150: '基础数据同步完成',
          13200: '同步完成',
          91320: '同步失败',
          91300: '出单失败',
          14000: '保单生效',
          15000: '犹豫期内',
          91500: '犹退',
          15100: '犹豫期后',
          17000: '保障中',
          91700: '犹豫期后退保',
          18000: '保单结束',
          91800: '保障期满',
          91810: '保障中止',
          91820: '保障终止'
        }
      }
    },
    computed: {
    
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },
      handlerSearch() {
        let filter = {}
        if (this.searchData.user_id) {
          filter.user_id = this.searchData.user_id
        }
        this.filter = filter
      }
    }
  }
</script>
